import React from 'react';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';

const Fortress = window.cccisd.fortress;

const CoursesTab = props => {
    return (
        <div style={{ margin: 'auto', maxWidth: '1270px' }}>
            <DeploymentPlayer
                deploymentHandle="aces_course"
                disableLayout
                pawnId={Fortress.user.acting.id}
                pawnHash={Fortress.user.acting.random_hash}
            />
        </div>
    );
};

export default CoursesTab;
